import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    gotoLocation, gotoMenu, setAlert, toggleResources
} from "../../store/actions/course.action";
import config from '../../config/config_data'
import _ from 'lodash'
import StringUtils from "../../store/utils/StringUtils";

import './HeaderNav.sass';
import HeaderProgressBar from "./HeaderProgressBar/HeaderProgressBar";

const HeaderNav = () => {
        const dispatch = useDispatch();
        const {courseData, courseLocation,pageStatus} = useSelector((state) => state.course);
        const [showDropDown, setShowDropDown] = useState(false);

        const goToMenuPage = () => {
            dispatch(gotoMenu());
        };

        const showResources = () => {
            dispatch(toggleResources(true, ''))
        }

        const toggleDropDown = () => {
            setShowDropDown(!showDropDown)
        }

        const handlePageRequest = (event, index) => {
            var ind = event.target.id.split("_");
            dispatch(gotoLocation([Number(ind[0]), Number(ind[1])]));
            setShowDropDown(false)
        }

        const requestExit = () => {
            if (!courseData.alerts) return null;
            let alert = _.find(courseData.alerts, {"id": "exit"});
            if (!alert) {
                return null
            } else {
                dispatch(setAlert(alert));
            }
            console.log("   alert: " + alert);
            console.log("   alert.body: " + alert.body);

        }

        const getChapterTitle = () => {
            if (courseLocation[0] === -1) {
                return "Main Menu"
            } else if (courseLocation[0] < -1) {
                return ""
            }
            let chapter = courseData.content[courseLocation[0]]
            return chapter.title
        }

        return (
            <div className="header-nav">
                {
                    (courseData && showDropDown) &&
                    <div className="header-nav-dropdown">
                        {
                            courseData.content.map((c, i) => (
                                <div className="header-nav-dropdown-section">
                                    <div className="header-nav-dropdown-title">
                                        {c.label || c.id}
                                    </div>
                                    {
                                        courseData.content[i].pages.map((page, index) => (
                                            <div className="header-nav-button"
                                                 id={i + "_" + index}
                                                 key={"item" + index}
                                                 onClick={(event) => {
                                                     handlePageRequest(event, index)
                                                 }}>
                                                {page.label || page.id}
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                }

                <div className="header-nav-left">
                    <div>
                        <img src={config.base_path+"/assets/images/icons/post_logo_45x45.png"}
                             alt={"POST logo"}
                             width="30px"
                             height={'30px'}/>
                    </div>
                    <div>
                    <span className="nav-title"
                          onClick={toggleDropDown}>{StringUtils.stripHTMLTags(getChapterTitle())}</span>
                    </div>
                </div>
                <HeaderProgressBar data={courseData.content} status={pageStatus}/>
                <div className="header-nav-right">
                    <button className="nav-btn"
                            onClick={() => {
                                goToMenuPage();
                            }}
                    >
                        MENU
                    </button>
                    {courseData.resourcesPath &&
                    <button className="nav-btn"
                            onClick={showResources}>RESOURCES
                    </button>
                    }

                    <button className="nav-btn"
                            onClick={requestExit}>EXIT
                    </button>
                </div>
            </div>
        );
    }
;

export default HeaderNav;
